export default __webpack_public_path__ + "assets/fonts/Nunito-Regular-794d9493.woff";